import { useAppDispatch } from '../redux/hooks';
import { invalidTokenModalActions } from '../redux/slices/invalid-token-modal-slice';
import SnackbarUtils from '../utils/SnackbarUtils';
import i18n from 'i18next';
import storageService, { Locals } from '../utils/storageService';
import { isNullOrUndefined } from '../utils/utils';

let dispatch = null;
export const GlobalErrorConfiguration = () => {
    dispatch = useAppDispatch();
    return null;
};

export default {
    handleError(error: { data: any; status: number }) {
        switch (true) {
            case error.status === 404:
                return;
            case error.status === 401:
                if (storageService.getItem(Locals.ACCESS_TOKEN)) {
                    //session expired
                    dispatch(invalidTokenModalActions.showModal());
                } else {
                    //invalid login
                    SnackbarUtils.error(
                        i18n.t('ERROR.LOGIN_ERROR', { ns: 'errors' })
                    );
                }
                return;
            case !isNullOrUndefined(error.data.message):
                if (
                    i18n.exists('ERROR.' + error.data.message, {
                        ns: 'errors',
                    })
                ) {
                    SnackbarUtils.error(
                        i18n.t('ERROR.' + error.data.message, {
                            ns: 'errors',
                        })
                    );
                } else {
                    SnackbarUtils.error(error.data.message);
                }
                return;
            default:
                SnackbarUtils.error(
                    i18n.t('ERROR.GLOBAL_ERROR', { ns: 'errors' })
                );
        }
    },
};
